import DashboardCardList, { DashboardCardListProps } from './DashboardCardList';

export type { DashboardCardListProps };
export default DashboardCardList;
